import appStore from 'store';
import api from './api';
import { STATUS_TYPES, PROJECT_TYPES } from './constants';
import LANGUAGE from 'common/languages';

const store = {
  namespaced: true,
  state: {
    projects: [],
    totalCount: 0,
    editingProject: {},
    pagination: {
      page: 1,
      size: 25
    },
    languageList: Object.keys(LANGUAGE).map(item => {
      return {
        value: item.toString(),
        label: LANGUAGE[item]
      };
    }),
    typeList: PROJECT_TYPES,
    coinList: [],
    detailDialogVisible: false
  },
  getters: {
    projectList: state =>
      state.projects.map(item => ({
        ...item,
        __problem: item.title['1'],
        __status: STATUS_TYPES[item.status],
        __type: PROJECT_TYPES.find(type => type.value == item.type).label,
        __result:
          item.result !== null
            ? item.options.find(option => option.id === item.result).value['1']
            : undefined
      })),
    coinList: state =>
      state.coinList.map(item => {
        return {
          label: item,
          value: item
        };
      })
  },
  mutations: {
    setList(state, payload) {
      state.projects = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setEditingProject(state, payload) {
      state.editingProject = payload;
    },
    setAllCoins(state, payload) {
      state.coinList = payload;
    },
    setDetailDialogVisible(state, payload) {
      state.detailDialogVisible = payload;
    }
  },
  actions: {
    getList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    create(context, data) {
      return api.create(data);
    },
    update(context, data) {
      return api.update(data);
    },
    setResult(context, data) {
      return api.setResult(data);
    },
    getAllCoins({ commit }) {
      api.getAllCoins().then(({ data }) => {
        commit('setAllCoins', data);
      });
    },
    enable(context, data) {
      return api.enable(data);
    },
    disable(context, data) {
      return api.disable(data);
    }
  }
};

appStore.registerModule('quiz', store);
